export default __webpack_public_path__ + "static/media/25083001.3b871d96.jpg";